define([
  "knockout",
  "jquery",
  "underscore",
  "globals",
  "dictionary-controller",
  "slick"],
  function (ko, $, _, globals, dictionaryController) {

    "use strict";

    var slickSlider = function (additionalContentObservable) {
      var slickSliderContainer = $(".bdc-dictionary-slick-slider");
      var options = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      };

      if (slickSlider.isInitialized) return;

      slickSliderContainer.slick(options);

      additionalContentObservable.subscribe(function (newValue) {
        slickSliderContainer.slick("unslick");

        var additionalContentSlide = $(".bdc-definition-additional-content");

        additionalContentSlide.empty().append(newValue);
        slickSliderContainer.slick(options);
      });

      slickSlider.isInitialized = true;
    };
    slickSlider.isInitialized = false;

    ko.bindingHandlers.dictionaryBinding = {

      init: function (element, valueAccessor) {

        var textToParse = element.innerHTML;
        if (valueAccessor() && valueAccessor().textToParse) {
          textToParse = ko.utils.unwrapObservable(valueAccessor().textToParse);
        }

        var dictionary = globals.dictionaryTerms.terms;
        if (valueAccessor() && valueAccessor().dictionaryEntries) {
          dictionary = ko.utils.unwrapObservable(valueAccessor().dictionaryEntries);
        }

        var tagMode = "hover";
        if (valueAccessor() && valueAccessor().tagMode) {
          tagMode = ko.utils.unwrapObservable(valueAccessor().tagMode);
        }

        String.prototype.regexIndexOf = function (regex, startpos) {
          var indexOf = this.substring(startpos || 0).search(regex);
          return (indexOf >= 0) ? (indexOf + (startpos || 0)) : indexOf;
        };

        var replacementStrategyFactory = function (strategy) {

          var hoverStrategy = function (term, uri, innerText) {

            return "<a href='" + uri + "?term=" + encodeURIComponent(term) + "' \
                     class='dictionary-term'> \
                    <span class='dictionary-term'></span>" + innerText + " \
                  </a>";
          };

          var staticStrategy = function (term, uri, innerText) {
            const isTHD = globals.siteId === 11
            return `
            <a
              href="${uri}?term=${encodeURIComponent(term)}"
              class='bdc-dictionary-term bdc-dictionary-term-static relative dib'
            >
              <span data-type="term-caller" class="${isTHD
                ? 'w2 h2 db absolute center nt4 left-0 right-0 flex items-center justify-center bg-black br-pill white b pointer i serif'
                : 'bdc-dictionary-term-caller'}"
              >
                ${isTHD ? 'i' : ''}
              </span>
              ${innerText}
            </a>
          `;
          };

          var noChangeStrategy = function (term, uri, innerText) {
            return innerText;
          };

          switch (strategy) {
            case "static":
              return staticStrategy;
            case "noChange":
              return noChangeStrategy;
            default:
              return hoverStrategy;
          }

        };

        function addMatchIfNotExists(matches, matchesWePlanToUse) {
          _.each(matches, function (match) {
            var foundOverlappingMatch = false;
            _.each(matchesWePlanToUse, function (existingReplacementString) {
              if (existingReplacementString.toIndex > match.fromIndex && existingReplacementString.fromIndex < match.toIndex) {
                foundOverlappingMatch = true;
              }
            });

            if (!foundOverlappingMatch) {
              matchesWePlanToUse.push(match);
            }
          });
        }

        if (!dictionary || !dictionary.length) {
          element.innerHTML = textToParse;
          return;
        }

        if (!textToParse) {
          return;
        }

        function isEmptyOrWhiteSpace(str) {
          return str === null || str.match(/^ *$/) !== null;
        }

        function getIndicesOf(stringToSearch, stringToMatch, caseSensitive, strategy, enforceWordBoundaries) {
          var originalStringToSearch = stringToSearch;
          var originalStringToMatch = stringToMatch;
          var indices = [];
          var match;

          if (isEmptyOrWhiteSpace(stringToMatch)) { return indices; }

          if (enforceWordBoundaries) {
            stringToMatch = "\\b" + stringToMatch + "\\b";
          }

          var flags = (caseSensitive) ? "g" : "gi";
          var re = new RegExp(stringToMatch, flags);

          while ((match = re.exec(stringToSearch)) !== null) {
            var fIndex = re.lastIndex - match[0].length;
            var tIndex = re.lastIndex;
            var indexMatch = {
              fromIndex: fIndex,
              toIndex: tIndex,
              replacement: strategy(originalStringToMatch, globals.dictionaryEntryForTerm, originalStringToSearch.substring(fIndex, tIndex))
            };
            indices.push(indexMatch);
          }

          return indices;
        }

        var matchesWePlanToUse = [];

        // Find and add all of the HTML tags to the list of matches
        var tags = getIndicesOf(textToParse, "<[^>]+>", false, replacementStrategyFactory("noChange"), false);
        addMatchIfNotExists(tags, matchesWePlanToUse);

        _.each(dictionary, function (dictionaryEntry) {
          var terms = getIndicesOf(textToParse, dictionaryEntry.Term, dictionaryEntry.IsCaseSensitive, replacementStrategyFactory(tagMode), true);
          addMatchIfNotExists(terms, matchesWePlanToUse);
        });

        matchesWePlanToUse.sort(function (a, b) {
          return b.toIndex - a.toIndex;
        });

        _.each(matchesWePlanToUse, function (replacementVal) {
          textToParse = textToParse.substring(0, replacementVal.fromIndex) + replacementVal.replacement + textToParse.substring(replacementVal.toIndex);
        });

        element.innerHTML = textToParse;

        $(element).find(".video-click").each(function () {
          if ($(this).html() === "") {
            $(this).next().find(".bdc-dictionary-term-caller").remove();
          }
        });

        var termElements = $(element).find(".bdc-dictionary-term");

        // Check if the term is a video term
        termElements.each(function () {
          var termElement = $(this);
          var href = termElement.attr("href");
          dictionaryController.getTerm(href).then(function (termData) {
            if (termData.hasVideo) {
              termElement.addClass('bdc-dictionary-video-term');
            }
          });
        });
      }
    };

    ko.bindingHandlers.dictionaryBindingIcon = {
      init: function (element, valueAccessor) {
        var dictionary = globals.dictionaryTerms.terms;
        var textToParse = valueAccessor().textToParse;
        var id = valueAccessor().id;
        var term;
        var i = 0;

        while (i < dictionary.length) {
          if (dictionary[i].IsCaseSensitive) {
            if (textToParse.indexOf(dictionary[i].Term) > -1) {
              term = dictionary[i].Term;
            }
          }
          else {
            if (textToParse.toLowerCase().indexOf(dictionary[i].Term.toLowerCase()) > -1) {
              term = dictionary[i].Term;
            }
          }

          if (term) {
            i = dictionary.length;
          }
          else {
            i++;
          }
        }

        if (term) {
          element.innerHTML = element.innerHTML + `
          <a
            href="${globals.dictionaryEntryForTerm}?term=${encodeURIComponent(term)}"
            class='bdc-dictionary-term bdc-dictionary-term-static'
          >
            <span id="icon-caller-choice-${id}" data-type="term-caller" class="bdc-dictionary-term-icon"></span>
          </a>
        `;

          var termElements = $(element).find(".bdc-dictionary-term");

          // Check if the term is a video term
          termElements.each(function () {
            var termElement = $(this);
            var href = termElement.attr("href");
            dictionaryController.getTerm(href).then(function (termData) {
              if (termData.hasVideo) {
                termElement.addClass('bdc-dictionary-video-term');
              }
            });
          });
        };

      }
    }
  });
